import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import AboutPage from '@/pages/about/page';
import IssuesPage from '@/pages/issues/page';
import AdminUsersPage from '@/pages/admin/users/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/issues', element: <IssuesPage /> },
  { path: '/issues/:slug', element: <IssuesPage /> },
  { path: '/admin/users', element: <AdminUsersPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;